<template>
  <div id="app">
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <template v-for="(route,index) in $router.options.routes"
                v-if='$route.matched.length && $route.matched[0].path===route.path'>
        <el-menu
          :key='index'
          default-active="1"
          unique-opened router
          style="min-height: 800px;text-align: left"
          >
          <template v-if="!route.hidden">
            <template
              v-for="(item, index) in route.children">
                <template v-if="!item.hidden">
                  <template v-if="$store.getters.getStorage.user.user.roleName === 'manager' || item.meta.roles === $store.getters.getStorage.user.user.roleName">
                    <!-- <template v-if="true"> -->
                  <el-submenu  v-if="item.children" :index="route.path + '/'+item.path" :key="index">
                    <template slot="title">
                      <!--<i :class="'fa fa-'+item.icon"></i>-->
											<i class="el-icon-menu"></i>
                      <span slot="title" style="font-size: 16px;">{{item.meta.title}}</span>
                    </template>
										<el-menu-item v-for="(data, index) in item.children"
																	v-if="!data.hidden && !data.children"
																	:index="route.path + '/'+item.path + '/' + data.path"
																	:key="index">
																	 <i class="el-icon-tickets"></i> 
										<span slot="title" style="font-size: 16px;">{{data.meta.title}}</span>
										</el-menu-item>
										<template
											v-for="(second, index) in item.children">
											<template v-if="!second.hidden">
												<el-submenu  v-if="second.children" :index="route.path + '/'+item.path + '/'+second.path" :key="index">
													<template slot="title">
														 <i class="el-icon-tickets"></i> 
														<span slot="title" style="font-size: 16px;">{{second.meta.title}}</span>

														<!-- 第四层子菜单 -->
														<!-- <template
															v-for="(third, index) in second.children">
															<template v-if="!third.hidden">
																<el-submenu  v-if="third.children" :index="route.path + '/'+item.path + '/'+second.path + third.path" :key="index">

																	<span slot="title">{{third.meta.title}}</span>

																</el-submenu>
															</template>
														</template> -->
															<!-- 第四层子菜单end -->
															</template>
															<el-menu-item v-for="(third, index) in second.children"
																						v-if="!third.hidden"
																						:index="route.path + '/'+item.path + '/'+second.path + '/' + third.path"
																						:key="index">
																						<!-- <i class="el-icon-tickets"></i> -->
															<span slot="title" style="font-size: 16px;">{{third.meta.title}}</span>
															</el-menu-item>

												</el-submenu>
											</template>
										</template>

                    <!-- <el-menu-item v-for="(data, index) in item.children"
                                  v-if="!data.hidden"
                                  :index="route.path + '/'+item.path + '/' + data.path"
                                  :key="index">
                      <i :class="'fa fa-'+data.icon"></i>-->
										<!-- <span slot="title">{{data.meta.title}}</span> -->



										<!--孙子-->
											<!-- <template v-if="!data.hidden">

												<el-submenu  v-if="data.children"
												:index="route.path + '/'+item.path + '/' + data.path"
												:key="index">

													<el-menu-item
														v-for="(submenu, index) in data.children"
														v-if="!submenu.hidden"
														:index="route.path + '/'+item.path + '/' + data.path+ '/' + submenu.path"
														:key="index" >
															<span slot="title">{{submenu.meta.title}}</span>
													</el-menu-item>

												</el-submenu>
											</template> -->
											<!--孙子-->

                    <!-- </el-menu-item> -->
                  </el-submenu>

									<!--爷爷-->
                  <el-menu-item v-else :index="route.path + '/'+item.path" :key="index">
                   <i :class="'fa fa-'+item.icon"></i>
                   <i class="el-icon-tickets"></i>
                    <span slot="title" style="font-size: 16px;">{{item.meta.title}}</span>
                  </el-menu-item>
									<!--爷爷-->
                </template>
                </template>
            </template>
          </template>

				</el-menu>
      </template>
    </el-scrollbar>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        sysUserName: '',
        sysUserAvatar: '',
        collapsed: false,
        fj:true,
        win_size: {
          height: ''
        }
      }
    },
    mounted() {
      // //初始化
      // if(this.$store.getters.getStorage.city ==='fj'){
      //   this.fj =false;
      // }
    },
    methods: {
      projectReport() {
        this.$router.push("/constructionUnit/projectReport");
      },
// 			need1() {
// 				this.$router.push("/constructionUnit/need1");
// 			},
      projectQueryList(){
        this.$router.push("/constructionUnit/projectQueryList");
      },
      ticketOpeningList(){
        this.$router.push("/constructionUnit/ticketOpeningList");
      },
      contractStatisticsList(){
        this.$router.push("/constructionUnit/contractStatisticsList");
      },
      contractTemplateList(){
        this.$router.push("/constructionUnit/contractTemplateList");
      },
      projectChangeList(){
        this.$router.push("/constructionUnit/projectChangeList");
      },
      currentPath() {
        let path = this.$route.path
        let stockPath = '/constructionUnit/projectChangeList'
        if (path.indexOf(stockPath) > -1) {
          return stockPath
        }
        return path
      },
      setSize() {
        this.win_size.height = $(window).height() + "px";
      },
      //折叠导航栏
    } , created() {
      this.setSize();
      $(window).resize(() => {
        this.setSize();
      });
    },destroyed() {
      $(window).off('resize');
    },
  }
</script>
<style>
  html,body,#app{
    height: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/components/ConstructionLeft.vue